import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule, CheckboxModule, InputModule, RadioModule, SelectModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ItemOrQuantityDomesticFormGroup } from '../../../models/cod-create.model';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { filter, tap } from 'rxjs';
import { Store } from '@ngxs/store';
import { AddCurrentCodLine, AddErrorMessage, RemoveErrorMessage } from '../../../state/cod.action';
import { WorkflowError } from '../../../../shared/enums/workflow-error';
import { ManagerSelectComponent } from '../../../../shared/components/manager-select/manager-select.component';

@Component({
    selector: 'app-cod-item-or-quantity-domestic-step',
    templateUrl: './item-or-quantity-domestic.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        FormsModule,
        ReactiveFormsModule,
        RadioModule,
        CheckboxModule,
        ButtonModule,
        TextareaModule,
        AttachmentsInputComponent,
        ManagerSelectComponent
    ],
    standalone: true
})
export class CodItemOrQuantityDomesticStepComponent implements OnInit {
    @Input() itemOrQuantityDomesticForm: FormGroup<ItemOrQuantityDomesticFormGroup> | undefined;

    private relatedCallTrackingNumberTouched = false;

    constructor(private store: Store) { }

    ngOnInit(): void {
        this.initFinancialAdjustmentChangesListener();
        this.initCallTagTrackingNumberTouchedListener();
        this.initRelatedDocumentsListener();
        this.updateValidity();
    }

    public handleConfirm() {
        if (this.itemOrQuantityDomesticForm?.valid) {
            this.store.dispatch(new AddCurrentCodLine());
        }
    }

    public isValid(): boolean {
        return this.itemOrQuantityDomesticForm?.valid ?? false;
    }

    private initFinancialAdjustmentChangesListener(): void {
        this.itemOrQuantityDomesticForm?.controls.financialAdjustment.valueChanges
           .pipe(
                tap(value => {
                    if (value === false) {
                        this.itemOrQuantityDomesticForm?.controls.adjustmentAmount.setValue(0);
                        this.itemOrQuantityDomesticForm?.controls.filedWithin30Days.setValue(null);
                        this.itemOrQuantityDomesticForm?.controls.managerApprovedRequest.setValue(null);
                    }
                })
            )
            .subscribe();
    }

    private initCallTagTrackingNumberTouchedListener(): void {
        this.itemOrQuantityDomesticForm?.controls.callTagTrackingNumber.valueChanges
            .pipe(
                filter(() => !this.relatedCallTrackingNumberTouched),
                tap(() => {
                    this.store.dispatch(new AddErrorMessage(WorkflowError.UPLOAD_PROOF));

                    this.relatedCallTrackingNumberTouched = true;
                })
            )
            .subscribe();
    }

    private initRelatedDocumentsListener(): void {
        this.itemOrQuantityDomesticForm?.controls.relatedDocuments.valueChanges
            .pipe(
                filter(value => !!value && value.length > 0),
                tap(() => this.store.dispatch(new RemoveErrorMessage(WorkflowError.UPLOAD_PROOF)))
            )
            .subscribe();
    }

    private updateValidity(): void {
        this.itemOrQuantityDomesticForm?.valueChanges
            .pipe(tap(() => this.itemOrQuantityDomesticForm?.updateValueAndValidity()))
            .subscribe();
    }
}
